export default {
  participants: state => state.participants,

  isMember: state => userId => {
    const participants = state.participants || []
    const i = participants.findIndex(participant => participant.userId === userId)
    return i !== -1
  }
}
